module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_location_fukuginamiki-8f18d8c29d1084af0575061ff6ee4fed.jpg";